export const testTranslations = {
  fr: {
    nav: 'Test gratuit',
    intro: {
      badge: 'Test gratuit · 2 minutes',
      title: 'Quelle place prenez-vous dans vos relations ?',
      subtitle: '5 questions pour mieux comprendre la place que vous prenez spontanément avec les autres.',
      description: 'Un test simple et bienveillant pour observer votre posture relationnelle et ouvrir une première piste de compréhension de vous-même.',
      startButton: 'Commencer le test',
      points: ['5 questions à choix multiples', 'Résultat personnalisé immédiat', '100 % gratuit et confidentiel']
    },
    progress: 'Question',
    of: 'sur',
    back: 'Précédent',
    questions: [
      {
        id: 'q1',
        text: 'Quand une situation devient compliquée autour de vous, votre premier réflexe est plutôt de…',
        options: [
          { key: 'A', text: 'Chercher rapidement une solution et prendre les choses en main.', profile: 'pilier' },
          { key: 'B', text: 'Essayer de calmer les tensions et de préserver l\'entente.', profile: 'conciliateur' },
          { key: 'C', text: 'Prendre un peu de recul et gérer ce qui vous concerne de votre côté.', profile: 'independant' },
          { key: 'D', text: 'Vous demander ce que les autres pensent ou ressentent réellement.', profile: 'sensible' }
        ]
      },
      {
        id: 'q2',
        text: 'Dans votre famille ou votre couple, qu\'est-ce qui vous ressemble le plus ?',
        options: [
          { key: 'A', text: 'On compte souvent sur moi pour organiser, décider ou trouver des solutions.', profile: 'pilier' },
          { key: 'B', text: 'Je fais facilement des compromis pour que tout se passe bien.', profile: 'conciliateur' },
          { key: 'C', text: 'J\'ai besoin de garder mon espace et une certaine liberté.', profile: 'independant' },
          { key: 'D', text: 'Je suis très sensible aux changements d\'attitude, aux silences ou aux non-dits.', profile: 'sensible' }
        ]
      },
      {
        id: 'q3',
        text: 'Lorsque quelqu\'un que vous aimez va mal…',
        options: [
          { key: 'A', text: 'Vous cherchez immédiatement ce que vous pourriez faire pour l\'aider.', profile: 'pilier' },
          { key: 'B', text: 'Vous vous adaptez beaucoup pour ne pas ajouter de difficultés.', profile: 'conciliateur' },
          { key: 'C', text: 'Vous êtes présent, mais vous essayez de ne pas vous laisser absorber par la situation.', profile: 'independant' },
          { key: 'D', text: 'Son état émotionnel peut rapidement avoir une influence sur le vôtre.', profile: 'sensible' }
        ]
      },
      {
        id: 'q4',
        text: 'Qu\'est-ce qui est généralement le plus difficile pour vous ?',
        options: [
          { key: 'A', text: 'Lâcher prise et accepter que les autres fassent les choses différemment.', profile: 'pilier' },
          { key: 'B', text: 'Dire non lorsque vous savez que cela risque de déplaire.', profile: 'conciliateur' },
          { key: 'C', text: 'Demander de l\'aide ou montrer que vous avez besoin de quelqu\'un.', profile: 'independant' },
          { key: 'D', text: 'Ne pas interpréter un silence, une distance ou un changement de comportement.', profile: 'sensible' }
        ]
      },
      {
        id: 'q5',
        text: 'Quand vous pensez à vos relations importantes, quelle phrase vous ressemble le plus ?',
        options: [
          { key: 'A', text: '« Si je ne m\'en occupe pas, qui va le faire ? »', profile: 'pilier' },
          { key: 'B', text: '« Je préfère parfois céder plutôt que créer un conflit. »', profile: 'conciliateur' },
          { key: 'C', text: '« J\'aime les autres, mais j\'ai besoin de rester libre. »', profile: 'independant' },
          { key: 'D', text: '« J\'ai besoin de sentir que le lien entre nous est solide. »', profile: 'sensible' }
        ]
      }
    ],
    capture: {
      title: 'Presque terminé !',
      subtitle: 'Entrez votre prénom et votre email pour découvrir votre résultat complet.',
      firstName: 'Prénom',
      firstNamePlaceholder: 'Votre prénom',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      submitButton: 'Voir mon résultat',
      submitting: 'Un instant...',
      privacy: 'Vos informations restent confidentielles.',
      teaserReady: 'Votre résultat est prêt',
      teaserIntro: 'Indiquez votre prénom et votre e-mail pour découvrir votre profil.',
      lockedItems: ['Votre place dans vos relations, en détail', 'Une question à explorer', 'Une première piste pour mieux vous comprendre'],
      consentBefore: 'J\'accepte que mes données soient utilisées afin d\'être recontacté(e) conformément à la ',
      consentLink: 'Politique de confidentialité',
      consentAfter: '.',
      consentError: 'Merci d\'accepter la politique de confidentialité pour continuer.',
      errorEmail: 'Merci d\'entrer un prénom et un email valides.',
      errorGeneric: 'Une erreur est survenue. Veuillez réessayer.'
    },
    profiles: {
      pilier: {
        name: 'Le Pilier',
        description: 'Vous avez tendance à prendre naturellement les choses en charge. On peut compter sur vous, et cette capacité à soutenir, organiser et trouver des solutions est une véritable force. Mais à force d\'être celui ou celle qui tient, vous pouvez finir par porter ce qui ne vous appartient pas ou avoir du mal à laisser les autres prendre leur part.',
        forces: [],
        defis: [],
        question: 'Avez-vous appris, à un moment de votre histoire, qu\'il fallait être fort ou responsable pour que tout tienne ?'
      },
      conciliateur: {
        name: 'Le Conciliateur',
        description: 'Vous accordez beaucoup d\'importance à l\'harmonie dans vos relations. Vous savez écouter, vous adapter et comprendre plusieurs points de vue. Mais cette capacité peut parfois vous conduire à faire passer les besoins des autres avant les vôtres, simplement pour éviter la tension, la déception ou le conflit.',
        forces: [],
        defis: [],
        question: 'Jusqu\'où pouvez-vous vous adapter sans vous éloigner de ce que vous voulez vraiment ?'
      },
      independant: {
        name: 'L\'Indépendant',
        description: 'Vous avez besoin de conserver votre autonomie et votre espace personnel. Vous savez avancer seul et vous n\'aimez généralement pas dépendre des autres. C\'est une force, mais cette indépendance peut aussi devenir une manière de vous protéger ou de ne pas montrer votre vulnérabilité.',
        forces: [],
        defis: [],
        question: 'Votre autonomie est-elle toujours un choix ou parfois une façon de ne pas avoir besoin des autres ?'
      },
      sensible: {
        name: 'Le Sensible au lien',
        description: 'Vous percevez facilement les ambiances, les changements d\'attitude et ce qui n\'est pas forcément exprimé. Cette sensibilité vous permet souvent de comprendre les autres avec beaucoup de finesse. Mais elle peut également vous conduire à chercher dans le comportement de l\'autre des réponses sur votre propre place.',
        forces: [],
        defis: [],
        question: 'Pouvez-vous vous sentir en sécurité dans une relation sans avoir constamment besoin de vérifier que le lien est intact ?'
      }
    },
    result: {
      greeting: 'Bravo',
      yourProfile: 'La place que vous prenez le plus spontanément :',
      tieTitle: 'Vous naviguez entre deux places',
      tieLead: 'Vos deux tendances principales :',
      tieText: 'Vous semblez naviguer entre deux façons de prendre votre place. C\'est fréquent : notre posture peut changer selon que nous sommes en couple, en famille, avec nos enfants ou dans notre vie professionnelle.',
      questionTitle: 'Une question à explorer',
      closing: 'Se comprendre, c\'est aussi comprendre pourquoi certaines façons d\'être reviennent dans nos relations. Notre histoire, notre environnement familial, nos expériences et notre fonctionnement personnel façonnent la place que nous prenons aujourd\'hui. Mon accompagnement permet d\'aller plus loin : comprendre votre fonctionnement, mettre en lumière certaines répétitions et retrouver une place qui vous ressemble davantage.',
      ctaButton: 'Réserver mon appel découverte',
      ctaSub: '30 minutes pour échanger, sans engagement.',
      retake: 'Refaire le test'
    }
  },

  es: {
    nav: 'Test gratuito',
    intro: {
      badge: 'Test gratuito · 2 minutos',
      title: '¿Qué lugar ocupas en tus relaciones?',
      subtitle: '5 preguntas para comprender mejor el lugar que ocupas espontáneamente con los demás.',
      description: 'Un test sencillo y amable para observar tu postura relacional y abrir una primera vía de comprensión de ti mism@.',
      startButton: 'Empezar el test',
      points: ['5 preguntas de opción múltiple', 'Resultado personalizado inmediato', '100 % gratuito y confidencial']
    },
    progress: 'Pregunta',
    of: 'de',
    back: 'Anterior',
    questions: [
      {
        id: 'q1',
        text: 'Cuando una situación se complica a tu alrededor, tu primer reflejo suele ser…',
        options: [
          { key: 'A', text: 'Buscar rápidamente una solución y tomar las riendas.', profile: 'pilier' },
          { key: 'B', text: 'Intentar calmar las tensiones y preservar el entendimiento.', profile: 'conciliateur' },
          { key: 'C', text: 'Tomar algo de distancia y gestionar lo que te concierne por tu lado.', profile: 'independant' },
          { key: 'D', text: 'Preguntarte qué piensan o sienten realmente los demás.', profile: 'sensible' }
        ]
      },
      {
        id: 'q2',
        text: 'En tu familia o tu pareja, ¿qué es lo que más se parece a ti?',
        options: [
          { key: 'A', text: 'A menudo cuentan conmigo para organizar, decidir o encontrar soluciones.', profile: 'pilier' },
          { key: 'B', text: 'Hago fácilmente concesiones para que todo vaya bien.', profile: 'conciliateur' },
          { key: 'C', text: 'Necesito conservar mi espacio y cierta libertad.', profile: 'independant' },
          { key: 'D', text: 'Soy muy sensible a los cambios de actitud, los silencios o lo no dicho.', profile: 'sensible' }
        ]
      },
      {
        id: 'q3',
        text: 'Cuando alguien a quien quieres está mal…',
        options: [
          { key: 'A', text: 'Buscas inmediatamente qué podrías hacer para ayudarle.', profile: 'pilier' },
          { key: 'B', text: 'Te adaptas mucho para no añadir dificultades.', profile: 'conciliateur' },
          { key: 'C', text: 'Estás presente, pero intentas no dejarte absorber por la situación.', profile: 'independant' },
          { key: 'D', text: 'Su estado emocional puede influir rápidamente en el tuyo.', profile: 'sensible' }
        ]
      },
      {
        id: 'q4',
        text: '¿Qué es generalmente lo más difícil para ti?',
        options: [
          { key: 'A', text: 'Soltar y aceptar que los demás hagan las cosas de otra manera.', profile: 'pilier' },
          { key: 'B', text: 'Decir no cuando sabes que puede disgustar.', profile: 'conciliateur' },
          { key: 'C', text: 'Pedir ayuda o mostrar que necesitas a alguien.', profile: 'independant' },
          { key: 'D', text: 'No interpretar un silencio, una distancia o un cambio de comportamiento.', profile: 'sensible' }
        ]
      },
      {
        id: 'q5',
        text: 'Cuando piensas en tus relaciones importantes, ¿qué frase se parece más a ti?',
        options: [
          { key: 'A', text: '«Si no me ocupo yo, ¿quién lo hará?»', profile: 'pilier' },
          { key: 'B', text: '«A veces prefiero ceder antes que crear un conflicto.»', profile: 'conciliateur' },
          { key: 'C', text: '«Quiero a los demás, pero necesito seguir siendo libre.»', profile: 'independant' },
          { key: 'D', text: '«Necesito sentir que el vínculo entre nosotros es sólido.»', profile: 'sensible' }
        ]
      }
    ],
    capture: {
      title: '¡Casi terminado!',
      subtitle: 'Introduce tu nombre y tu email para descubrir tu resultado completo.',
      firstName: 'Nombre',
      firstNamePlaceholder: 'Tu nombre',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      submitButton: 'Ver mi resultado',
      submitting: 'Un momento...',
      privacy: 'Tus datos son confidenciales.',
      teaserReady: 'Tu resultado está listo',
      teaserIntro: 'Indica tu nombre y tu email para descubrir tu perfil.',
      lockedItems: ['Tu lugar en tus relaciones, en detalle', 'Una pregunta para explorar', 'Una primera pista para comprenderte mejor'],
      consentBefore: 'Acepto que mis datos sean utilizados para poder ser contactado(a) de acuerdo con la ',
      consentLink: 'Política de Privacidad',
      consentAfter: '.',
      consentError: 'Por favor acepta la política de privacidad para continuar.',
      errorEmail: 'Por favor introduce un nombre y un email válidos.',
      errorGeneric: 'Ha ocurrido un error. Por favor inténtalo de nuevo.'
    },
    profiles: {
      pilier: {
        name: 'El Pilar',
        description: 'Tiendes a hacerte cargo de las cosas de forma natural. Se puede contar contigo, y esa capacidad de sostener, organizar y encontrar soluciones es una verdadera fortaleza. Pero de tanto ser quien sostiene, puedes acabar cargando con lo que no te corresponde o costarte dejar que los demás asuman su parte.',
        forces: [],
        defis: [],
        question: '¿Aprendiste, en algún momento de tu historia, que había que ser fuerte o responsable para que todo se sostuviera?'
      },
      conciliateur: {
        name: 'El Conciliador',
        description: 'Das mucha importancia a la armonía en tus relaciones. Sabes escuchar, adaptarte y comprender varios puntos de vista. Pero esa capacidad puede llevarte a veces a poner las necesidades de los demás por delante de las tuyas, simplemente para evitar la tensión, la decepción o el conflicto.',
        forces: [],
        defis: [],
        question: '¿Hasta dónde puedes adaptarte sin alejarte de lo que realmente quieres?'
      },
      independant: {
        name: 'El Independiente',
        description: 'Necesitas conservar tu autonomía y tu espacio personal. Sabes avanzar solo y, por lo general, no te gusta depender de los demás. Es una fortaleza, pero esa independencia también puede convertirse en una manera de protegerte o de no mostrar tu vulnerabilidad.',
        forces: [],
        defis: [],
        question: '¿Tu autonomía es siempre una elección o a veces una forma de no necesitar a los demás?'
      },
      sensible: {
        name: 'El Sensible al vínculo',
        description: 'Percibes fácilmente los ambientes, los cambios de actitud y lo que no siempre se expresa. Esa sensibilidad te permite a menudo comprender a los demás con mucha finura. Pero también puede llevarte a buscar en el comportamiento del otro respuestas sobre tu propio lugar.',
        forces: [],
        defis: [],
        question: '¿Puedes sentirte seguro en una relación sin necesitar comprobar constantemente que el vínculo sigue intacto?'
      }
    },
    result: {
      greeting: 'Enhorabuena',
      yourProfile: 'El lugar que ocupas más espontáneamente:',
      tieTitle: 'Navegas entre dos lugares',
      tieLead: 'Tus dos tendencias principales:',
      tieText: 'Pareces navegar entre dos formas de ocupar tu lugar. Es frecuente: nuestra postura puede cambiar según estemos en pareja, en familia, con nuestros hijos o en nuestra vida profesional.',
      questionTitle: 'Una pregunta para explorar',
      closing: 'Comprenderse es también comprender por qué ciertas formas de ser se repiten en nuestras relaciones. Nuestra historia, nuestro entorno familiar, nuestras experiencias y nuestro funcionamiento personal moldean el lugar que ocupamos hoy. Mi acompañamiento permite ir más lejos: comprender tu funcionamiento, poner de relieve ciertas repeticiones y recuperar un lugar que se parezca más a ti.',
      ctaButton: 'Reservar mi llamada de descubrimiento',
      ctaSub: '30 minutos para hablar, sin compromiso.',
      retake: 'Repetir el test'
    }
  }
};
